import { createContext, useContext, useEffect } from 'react';

export type PageTitleSetter = (title: string | null) => void;

export const PageTitleContext = createContext<PageTitleSetter | null>(null);

export function usePageTitle(title: string) {
  const setTitle = useContext(PageTitleContext);
  useEffect(() => {
    if (!setTitle) return;
    setTitle(title);
    return () => setTitle(null);
  }, [title, setTitle]);
}
